import { RcClasses } from '../../../../foundation';
export var RcAccordionSummaryClasses = RcClasses(['content', 'expanded', 'expandIcon'], 'RcAccordionSummary');
